// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__304zs","info":"Note_info__raaC8","note":"Note_note__2lqG4","actions":"Note_actions__1Rfza"};